import classNames from 'classnames';
import { useMenuBalanceContext } from 'moduleBase/modules/menu-balance/hooks/use-menu-balance-context';
import * as React from 'react';
import app from 'srcJs/App';

const Frozen = () => {
  const { menu } = useMenuBalanceContext();

  if (!menu.frozen) {
    return null;
  }

  return (
    <div className="dropdown-flat-list">
      <div className={classNames(
        'dropdown-flat-list__item',
        'dropdown-flat-list__item_small-vertical-padding',
        'justify-content-between',
      )}
      >
        <span className="color-858585 mr-3">
          {app.tForReact('base', 'Frozen:')}
        </span>
        <span className="text-truncate text-dark">
          {menu.frozen}
        </span>
      </div>
    </div>
  );
};

export { Frozen };
